import axios from 'axios'
import qs from 'qs'
import { Message, Notification } from 'element-ui'
import { getToken } from '@/utils/auth'

function filterParams(params) {
  const result = {}

  Object.keys(params || {}).forEach(key => {
    const value = params[key]

    if (Array.isArray(value) && value.length > 0) {
      result[key] = value
      return
    }

    if (value && typeof value === 'object' && JSON.stringify(value) !== '{}') {
      result[key] = value
      return
    }

    if (value || value === 0) {
      result[key] = value
    }
  })

  return result
}

function normalizeConfig(config, options) {
  const nextConfig = config
  const requestOptions = nextConfig.vconfig || {}
  const defaultContentType =
    options.defaultContentType || 'application/x-www-form-urlencoded'

  nextConfig.vconfig = requestOptions
  nextConfig.headers = nextConfig.headers || {}

  if (!nextConfig.headers['Content-Type']) {
    nextConfig.headers['Content-Type'] = defaultContentType
  }

  if (requestOptions.baseApi || requestOptions.baseApi === '') {
    nextConfig.baseURL = requestOptions.baseApi
  } else if (requestOptions.noBaseApi && options.noBaseApi) {
    nextConfig.baseURL = options.noBaseApi
  }

  if (requestOptions.ContentType) {
    nextConfig.headers['Content-Type'] = requestOptions.ContentType
  }

  if (options.attachToken) {
    const token = getToken()

    if (token) {
      nextConfig.headers.Authorization = `Bearer ${token}`
    }
  }

  if (
    nextConfig.headers['Content-Type'] === 'application/x-www-form-urlencoded' &&
    nextConfig.data
  ) {
    nextConfig.data = qs.stringify(nextConfig.data)
  }

  if (requestOptions.responseType) {
    nextConfig.responseType = requestOptions.responseType
  }

  if (requestOptions.cancel) {
    nextConfig.cancelToken = new axios.CancelToken(cancel => {
      cancel('cancel')
    })
  }

  if (nextConfig.params) {
    nextConfig.params = filterParams(nextConfig.params)
  }

  return nextConfig
}

function handleResponse(response) {
  const requestOptions = (response.config && response.config.vconfig) || {}

  if (requestOptions.noErr) {
    return response
  }

  const payload = response.data || {}
  const code = Number(payload.code)

  if (Number.isNaN(code) || code === 0) {
    return payload
  }

  Notification.error({
    title: payload.error || 'Request failed'
  })

  return Promise.reject(payload)
}

function handleResponseError(error) {
  if (error && error.message === 'cancel') {
    return Promise.reject(error)
  }

  Message({
    message: (error && error.message) || 'Request failed',
    type: 'error',
    duration: 5 * 1000
  })

  return Promise.reject(error)
}

export default function createRequestService(options) {
  const service = axios.create({
    baseURL: options.baseURL,
    timeout: options.timeout || 120000
  })

  service.interceptors.request.use(
    config => normalizeConfig(config, options),
    error => Promise.reject(error)
  )

  service.interceptors.response.use(handleResponse, handleResponseError)

  return service
}
